import { REQUEST_API_TOKEN_GENERATION_FINISHED, REQUEST_REGISTER_INTERNAL_USER_FINISHED } from "./InternalUserAction";

const initialState = {
    confirmed: false
};

export default function internalUserReducer(state = initialState, action) {
    switch (action.type) {
        case REQUEST_REGISTER_INTERNAL_USER_FINISHED:
            if (action.payload.errors) {
                return {
                    ...state,
                };
            } else {
                return {
                    ...state,
                    confirmed: true
                };
            }
        case REQUEST_API_TOKEN_GENERATION_FINISHED:
            if (action.payload.errors) {
                return {
                    ...state,
                };
            } else {
                return {
                    ...state,
                    generatedToken: action.payload
                };
            }
        default:
            return state;
    }
}